// store/data/global.js
import { createSlice } from "@reduxjs/toolkit";
import video1 from '@/assets/Clients/Industry-2-2-1.mp4'
import video2 from '@/assets/Clients/Industry-2-2-2.mp4'

const globalSlice = createSlice({
  name: 'global',
  initialState: {
    currentLanguage: 'ES',
    translations: {
      IndexBannerList: {
        ES: {
          headerONE: 'Impulsando la Evolución',
          headerTWO: 'Suministro Global de Componentes Centrales para Servidores',
          subheader:'Adaptación para escenarios empresariales, industriales y de computación perimetral, potenciando la infraestructura digital de México.',
        },
        EN: {
          headerONE: 'Driven Evolution',
          headerTWO: 'Global Supply of Core Server Components',
          subheader: 'Adaptable for enterprise, industrial, and edge computing scenarios, empowering ESico’s digital infrastructure development.'
        }
      },
      IndexCoreBusiness: {
        ES: {
          caption: 'Alcance Central de Operaciones',
          subheader: 'Matriz de Cuatro Categorías de Productos',
          content:[
            {
              header: 'GPU y Componentes Centrales',
              icon:require('@/assets/home/Core-Business-Scope1.png'),
            },
            {
              header: 'Componentes de Almacenamiento y Tarjetas de Arreglo',
              icon:require('@/assets/home/Core-Business-Scope2.png'),
            },
            {
              header: 'Sistemas de Energía y Alimentación',
              icon:require('@/assets/home/Core-Business-Scope3.png'),
            },
             {
              header: 'Refrigeración y Componentes de Soporte',
              icon:require('@/assets/home/Core-Business-Scope4.png'),
            },
          ]
        },
        EN: {
          caption: 'Core Business Scope',
          subheader: 'Four Major Product Matrices ',
          content:[
            {
              header: 'GPU & Core Components ',
              icon:require('@/assets/home/Core-Business-Scope1.png'),
            },
            {
              header: 'Storage Components & RAID Cards',
              icon:require('@/assets/home/Core-Business-Scope2.png'),
            },
            {
              header: 'Power Supplies & Power Systems',
              icon:require('@/assets/home/Core-Business-Scope3.png'),
            },
             {
              header: 'Cooling & Supporting Components',
              icon:require('@/assets/home/Core-Business-Scope4.png'),
            },
          ]
        }
      },
      IndexValueList: {
        ES: [
           {
              header:'Matriz de Componentes para Todos los Escenarios',
              content:'Cubrimos demandas diversas como centros de datos empresariales, control industrial y nodos perimetrales, ofreciendo productos certificados y conformes por organismos oficiales ESicanos.',
              Img:require('@/assets/home/Core-Value-Module1.webp'),
           },
           {
              header:'Ventaja de la Cadena de Suministro Global',
              content:' Aprovechando la conveniencia geográfica, nos conectamos con almacenes de fabricantes a nivel global, comprimiendo el plazo de entrega de componentes clave a 3-5 días laborables.',
              Img:require('@/assets/home/Core-Value-Module2.webp'),
           },
           {
              header:'Servicios de Acompañamiento Personalizados',
              content:'Ofrecemos selección de componentes, pruebas de compatibilidad y soluciones de adaptación por volumen, según las características de industrias como retail, manufactura y salud.',
              Img:require('@/assets/home/Core-Value-Module3.webp'),
           },

        ],
        EN: [
           {
              header:'Full-scenario Component Matrix',
              content:' Covering diverse needs such as enterprise data centers, industrial control, and edge nodes, providing compliant products certified by ESican official authorities.',
              Img:require('@/assets/home/Core-Value-Module1.webp'),
           },
           {
              header:'Global Supply Chain Advantage',
              content:'Leveraging geographical c onvenience to connect with original factory warehouses worldwide, compressing the delivery cycle of core components to 3-5 working days for spot goods.',
              Img:require('@/assets/home/Core-Value-Module2.webp'),
           },
           {
              header:'Customized Supporting Services',
              content:'Providing component selection, compatibility testing, and bulk adaptation solutions tailored to the characteristics of retail, manufacturing, medical and other industries.',
              Img:require('@/assets/home/Core-Value-Module3.webp'),
           },

        ]
      },
      IndexCustomerList: {
        ES: [
          {
             evaluate: 'El equipo técnico siempre resuelve nuestros problemas en primer lugar; este apoyo profesional hace que la ejecución de nuestro proyecto sea mucho más fluida.',
             from:'Director de Producto de una empresa de tecnología',
             name:' Carlos Rodríguez',
             mark:require('@/assets/home/Customer-Evaluation.png'),
          },
          {
             evaluate:'Tras la implementación, el sistema funciona con gran estabilidad, sobresaliendo incluso bajo condiciones de alta carga, satisfaciendo completamente las necesidades de nuestro negocio.',
             from:'Directora de Operaciones de un centro de datos',
             name:'Sarah Johnson',
             mark:require('@/assets/home/Customer-Evaluation.png'),
          },
          {
             evaluate: 'Cada etapa, desde la comunicación de requisitos hasta la entrega final, refleja profesionalismo y dedicación, y la calidad del servicio durante todo el proceso también fue muy alta. Esperamos una cooperación futura más profunda.',
             from:'Director de TI de una empresa multinacional',
             name:'David Chen',
             mark:require('@/assets/home/Customer-Evaluation.png'),
          },                   
        ],
        EN: [
          {
             evaluate: 'The technical team always resolves our issues promptly; this professional support makes our project progress much smoother.',
             from:'Product Director of a Technology Company',
             name:'Carlos Rodriguez',
             mark:require('@/assets/home/Customer-Evaluation.png'),
          },
          {
             evaluate: 'After deployment, the system runs with great stability, performing excellently even under high-load conditions, fully meeting our business needs.',
             from:' Operation Supervisor of a Data Center',
             name:'Sarah Johnson',
             mark:require('@/assets/home/Customer-Evaluation.png'),
          },
          {
             evaluate: 'Every step, from requirement communication to final delivery, reflects professionalism and dedication, and the service quality throughout the entire process was also very high. We look forward to deeper future cooperation.',
             from:'IT Director of a Multinational Enterprise',
             name:'David Chen',
             mark:require('@/assets/home/Customer-Evaluation.png'),
          }, 
        ]
      },
      IndexFAQList: {
        ES: [
          {
             ask:'¿Los componentes adquiridos cumplen con los estándares de uso local en México?',
             answer: 'Todos los productos en venta cuentan con la certificación de instituciones locales oficiales en México, cumpliendo con los requisitos para múltiples escenarios de uso local. Pueden integrarse directamente a los sistemas existentes sin necesidad de equipos de conversión adicionales.',
          },
          {
             ask:'¿Cómo confirmar la compatibilidad de los componentes requeridos con los servidores existentes?',
             answer: 'Ofrecemos un servicio gratuito de prueba de compatibilidad. El cliente solo necesita proporcionar la marca, modelo, parámetros de configuración o número de pieza del servidor existente. Nuestro equipo técnico, combinando bases de datos del fabricante y datos de pruebas reales, emitirá un reporte de evaluación de compatibilidad para evitar riesgos en la adquisición.',
          },
          {
             ask:' Si el modelo del componente adquirido es incorrecto, ¿se puede gestionar la devolución o el cambio?',
             answer: 'Siempre que la mercancía no haya sido abierta y no afecte su reventa, se puede solicitar la devolución o cambio dentro de los 7 días laborables siguientes a la recepción. El cliente solo cubrirá los costos de logística de ida y vuelta. Si el error del modelo se debe a una cotización o comunicación incorrecta por nuestra parte, nosotros asumimos todos los costos de devolución/cambio y las pérdidas relacionadas.',
          },
          {
             ask:'Para necesidades personalizadas de industrias especiales, ¿pueden proporcionar soluciones exclusivas?',
             answer: 'Sí, admitimos servicios personalizados para todas las industrias. Ya sea la alta estabilidad requerida en el sector salud, la resistencia a interferencias en entornos industriales, o la relación costo-eficiencia en el retail, nuestro equipo técnico se coordinará exhaustivamente para diseñar soluciones de combinación de componentes exclusivas, adaptadas a las características de la industria.',
          },
        ],
        EN: [
          {
             ask:'Are the purchased components compliant with local usage standards in ESico?',
             answer:'All products for sale have been officially certified by local ESican institutions, meeting the requirements of various local scenarios. They can be directly connected to existing systems without the need for additional conversion equipment.',
          },
          {
             ask:'How to confirm the compatibility of the required components with existing servers?',
             answer:'We provide free compatibility testing services. Customers only need to provide the brand model, configuration parameters or hardware number of the existing server. Our technical team will issue a compatibility assessment report based on the original factory database and actual test data to avoid procurement risks.',
          },
          {
             ask:'Can I return or exchange components if the purchased model is incorrect?',
             answer:'Under the premise that the goods are unopened and do not affect secondary sales, returns or exchanges can be applied for within 7 working days from the date of receipt. Customers only need to bear the round-trip logistics costs; if the model error is caused by our quotation or communication mistakes, we will bear all return and exchange costs and related losses.',
          },
          {
             ask:'Can exclusive solutions be provided for customized needs of special industries?',
             answer:'We support customized services for all industries. Whether it is the high stability requirements of the medical industry, the anti-interference requirements of industrial scenarios, or the cost-effectiveness requirements of the retail industry, we can arrange a technical team to conduct in-depth docking and design exclusive component combination solutions based on industry characteristics.',
          },          
        ]
      },
      ProductsList: {//Products
        ES: [
          {
             header: 'GPU y Componentes Centrales',
             id:'gpu',
             content:'Centrándonos en la actualización del poder de cómputo de IA y las demandas de computación profesional, ofrecemos una selección curada de GPU de alto rendimiento de fabricantes líderes mundiales y componentes críticos para servidores. Estas soluciones están adaptadas para escenarios de aplicación principales en el mercado ESicano, como la implementación de virtualización, el entrenamiento de aprendizaje profundo y el modelado y renderizado 3D.',
             dataList:[
              {
                type:'NVIDIA RTX pro 6000',
                img:require('@/assets/Products/1-1.webp'),
              },
              {
                type:'NVIDIA H200',
                img:require('@/assets/Products/1-2.webp'),
              },
             ],            
          },
          {
             header: 'Componentes de Almacenamiento y Tarjetas de Arreglo',
             id:'storage',
             content:'Desarrollamos soluciones de almacenamiento centradas en "alta capacidad, alto rendimiento y baja latencia", adaptadas para el almacenamiento en centros de datos, bases de datos empresariales y escenarios de archivado y respaldo. Estas soluciones equilibran el rendimiento y el costo, satisfaciendo eficazmente las crecientes demandas de almacenamiento de las empresas ESicanas.',
             dataList:[
              {
                type:'WD Ultrastar DC HA340',
                img:require('@/assets/Products/2-1.webp'),
              },
              {
                type:'Micron 6500 ION',
                img:require('@/assets/Products/2-2.webp'),
              },
             ],            
          },
          {
             header: 'Sistemas de Energía y Alimentación',
             id:'power',
             content:'Enfocándonos en los requisitos clave del servidor de "alimentación eléctrica estable y alta eficiencia energética," ofrecemos soluciones de alimentación que cumplen con los estándares de eficiencia para centros de datos. Estas soluciones se adaptan a los entornos de red eléctrica en las diferentes regiones de México, ayudando a las empresas a reducir los costos operativos a largo plazo.',
             dataList:[
              {
                type:'Dell D2400E',
                img:require('@/assets/Products/3-1.webp'),
              },
              {
                type:'Artesyn 2400W CRPS',
                img:require('@/assets/Products/3-2.webp'),
              },  
             ],            
          },
          {
             header: 'Refrigeración y Componentes de Soporte',
             id:'cooling',
             content:'Aprovechando las características climáticas únicas de México, desarrollamos soluciones térmicas para servidores con resistencia a altas temperaturas y baja acústica, garantizando la estabilidad y confiabilidad del hardware incluso en condiciones ambientales extremas.',
             dataList:[
              {
                type:'Noctua NH-U14S DX-4677',
                img:require('@/assets/Products/4-1.webp'),
              },
              {
                type:'ARCTIC Freezer 4U-M',
                img:require('@/assets/Products/4-2.webp'),
              },
             ],            
          },      
        ],
        EN: [
          {
             header: 'GPU & Core Components',
             id:'gpu',
             content:' Focusing on AI computing power upgrades and professional computing needs, we offer a curated selection of high-performance GPUs from leading global manufacturers and critical server components. These solutions are tailored for mainstream application scenarios in the ESican market, including virtualized deployment, deep learning training, and 3D modeling & rendering. ',
             dataList:[
              {
                type:'NVIDIA RTX pro 6000',
                img:require('@/assets/Products/1-1.webp'),
              },
              {
                type:'NVIDIA H200',
                img:require('@/assets/Products/1-2.webp'),
              },
             ],            
          },
          {
             header: 'Storage Components & RAID Cards',
             id:'storage',
             content:'We build storage solutions centered on "high capacity, high throughput, and low latency", tailored for data center storage, enterprise-grade databases, and archiving/backup scenarios. These solutions strike a balance between performance and cost, effectively meeting the soaring storage demands of ESican businesses. ',
             dataList:[
              {
                type:'WD Ultrastar DC HA340',
                img:require('@/assets/Products/2-1.webp'),
              },
              {
                type:'Micron 6500 ION',
                img:require('@/assets/Products/2-2.webp'),
              },
             ],            
          },
          {
             header: 'Power Supplies & Power Systems',
             id:'power',
             content:'Centered on the core server requirements of "stable power supply and high energy efficiency," we provide power supply solutions that comply with data center energy efficiency standards. These solutions are adapted to the grid environments across different regions of ESico, helping businesses reduce long-term operational costs. ',
             dataList:[
              {
                type:'Dell D2400E',
                img:require('@/assets/Products/3-1.webp'),
              },
              {
                type:'Artesyn 2400W CRPS',
                img:require('@/assets/Products/3-2.webp'),
              },
             ],            
          },
          {
             header:'Cooling & Supporting Components',
             id:'cooling',
             content:' Leveraging ESico’s unique climate profile, we develop server thermal solutions with high-temperature resistance and low acoustics, ensuring hardware stability and reliability even under extreme environmental conditions. ',
             dataList:[
              {
                type:'Noctua NH-U14S DX-4677',
                img:require('@/assets/Products/4-1.webp'),
              },
              {
                type:'ARCTIC Freezer 4U-M',
                img:require('@/assets/Products/4-2.webp'),
              },
             ],            
          },          
        ]
      },
      ClientsOneList: {//Case Studies
       ES: [
            {        
              caption:' Industria 1',     
              headerOne: 'Medios y Entretenimiento',
              headerTwo: 'Producción Virtual y Renderizado en Tiempo Real',
              bgImg:require('@/assets/Clients/Industry-1.webp'),
            },                     
        ],
        EN: [
            {      
              caption:'Industry 1',   
              headerOne: 'Media & Entertainment',
              headerTwo: 'Virtual Production & Real-time Rendering',
              bgImg:require('@/assets/Clients/Industry-1.webp'),
            },          
        ]
      },
      ClientsOneTarget:{
       ES:{ 
            Header:'Clientes Objetivo',
            information:[
              {
                name:'Estudios de producción cinematográfica',
              },
              {
                name:'Estudios de animación y efectos visuales',
              },
              {
                name:'Agencias de publicidad creativa',
              },
            ]                     
        },
        EN:{      
            Header:'Target Clients',
            information:[
              {
                name:'Film Production Studios',
              },
              {
                name:'Animation & Visual Effects Studios',
              },
              {
                name:'Advertising Creative Agencies',
              },
            ]            
       }
      },
      ClientsOneSolutions:{
       ES:{ 
            Header:'Solución Contextualizada',
            information:[
              {
                topImg:require('@/assets/Clients/Industry-1-2-1.webp'),
                name:'Desafío Central',
                content:'Procesar material en resolución 8K, renderizar escenas 3D complejas en tiempo real, cumplir con los requisitos de baja latencia para producción virtual.', 
              },
              {
                topImg:require('@/assets/Clients/Industry-1-2-2.webp'),
                name:'Combinación de Productos Central de Referencia',
                content:'NVIDIA RTX Pro 6000, Micron 6500 ION', 
              },
            ]                     
        },
        EN:{      
            Header:'Scenario-based Solutions',
            information:[
              {
                topImg:require('@/assets/Clients/Industry-1-2-1.webp'),
                name:'Core Challenges',
                content:' Processing 8K resolution footage, real-time rendering of complex 3D scenes, meeting low-latency requirements for virtual production.', 
              },
              {
                topImg:require('@/assets/Clients/Industry-1-2-2.webp'),
                name:'Recommended Core Product Combination',
                content:'NVIDIA RTX Pro 6000, Micron 6500 ION', 
              },
            ]            
       }
      },
      ClientsTwoList: {//Case Studies
       ES: [
            {        
              caption:' Industria 2',     
              headerOne: 'Tecnología Financiera y Servicios',
              headerTwo: 'Análisis de Transacciones de Alta Frecuencia y Big Data',
              bgImg:require('@/assets/Clients/Industry-2.webp'),
            },                     
        ],
        EN: [
            {      
              caption:'Industry 2',         
              headerOne: 'Fintech & Services',
              headerTwo: 'High-Frequency Trading & Big Data Analytics',
              bgImg:require('@/assets/Clients/Industry-2.webp'),
            },          
        ]
      },
      ClientsTwoTarget:{
       ES:{ 
            Header:'Clientes Objetivo',
            information:[
              {
                code:'01',
                name:'Bancos comerciales y de inversión',
                video: video1,
              },
              {
                code:'02',
                name:'Empresas de tecnología financiera',
                video: video2,
              },
              {
                code:'03',
                name:'Grandes plataformas de comercio electrónico y medios',
                video: video1,
              },
            ]                     
        },
        EN:{      
            Header:'Target Clients',
            information:[
              {
                code:'01',
                name:'Commercial & Investment Banks',
                video: video1,
              },
              {
                code:'02',
                name:'Fintech Companies',
                video: video2,
              },
              {
                code:'03',
                name:'Large E-commerce & Media Platforms',
                video: video1,
              },
            ]            
       }
      }, 
      ClientsTwoSolutions:{
       ES:{ 
            Header:'Solución Contextualizada',
            information:[
              {
                topImg:require('@/assets/Clients/Industry-2-3-1.webp'),
                name:'Desafío Central',
                content:'Realizar simulaciones de riesgo en milisegundos, procesar grandes volúmenes de datos de transacciones en tiempo real, ejecutar algoritmos de recomendación personalizados.', 
              },
              {
                topImg:require('@/assets/Clients/Industry-2-3-2.webp'),
                name:'Combinación de Productos Central de Referencia',
                content:'NVIDIA H200, WD Ultrastar DC HA340',  
              },
            ]                     
        },
        EN:{      
            Header:'Scenario-based Solutions',
            information:[
              {
                topImg:require('@/assets/Clients/Industry-2-3-1.webp'),
                name:'Core Challenges',
                content:'Conducting millisecond-level risk simulation, processing massive real-time transaction data, running personalized recommendation algorithms.',              
              },
              {
                topImg:require('@/assets/Clients/Industry-2-3-2.webp'),
                name:'Recommended Core Product Combination',
                content:'NVIDIA H200, WD Ultrastar DC HA340', 
              },
            ]            
       }
      }, 
      ClientsThreeList: {//Case Studies
       ES: [
            {        
              caption:'Industria 3',     
              headerOne: 'Medicina y Ciencias de la Vida',
              headerTwo: 'Genómica e Imagenología Médica',
              bgImg:require('@/assets/Clients/Industry-3.webp'),
            },                     
        ],
        EN: [
            {      
              caption:'Industry 3',         
              headerOne: 'Healthcare & Life Sciences',
              headerTwo: 'Genomics & Medical Imaging',
              bgImg:require('@/assets/Clients/Industry-3.webp'),
            },          
        ]
      },
      ClientsThreeTarget:{
       ES:{ 
            Header:'Clientes Objetivo',
            information:[
              {
                name:' Universidades e institutos de investigación',
              },
              {
                name:'Hospitales y centros de imagenología médica',
              },
              {
                name:'Empresas de biotecnología y farmacéuticas',
              },
            ]                     
        },
        EN:{      
            Header:'Target Clients',
            information:[
              {
                name:'Universities & Research Institutions',
              },
              {
                name:'Hospitals & Medical Imaging Centers ',
              },
              {
                name:'Biotechnology & Pharmaceutical Companies ',
              },
            ]            
       }
      }, 
      ClientsThreeSolutions:{
       ES:{ 
            Header:'Solución Contextualizada',
            information:[
              {
                topImg:require('@/assets/Clients/Industry-3-2-1.webp'),
                name:'Desafío Central',
                content:'Acelerar el análisis de secuenciación genómica, entrenar modelos de IA para diagnóstico de enfermedades, almacenar y gestionar grandes volúmenes de datos médicos.'
              },
              {
                topImg:require('@/assets/Clients/Industry-3-2-2.webp'),
                name:'Combinación de Productos Central de Referencia',
                content:'NVIDIA RTX Pro 6000, WD Ultrastar DC HA340' 
              },
            ]                     
        },
        EN:{      
            Header:'Scenario-based Solutions',
            information:[
              {
                topImg:require('@/assets/Clients/Industry-3-2-1.webp'),
                name:'Core Challenges',
                content:'Accelerating genomic sequencing analysis, training AI models for disease diagnosis, storing and managing massive medical data.'
              },
              {
                topImg:require('@/assets/Clients/Industry-3-2-2.webp'),
                name:'Recommended Core Product Combination',
                content:'NVIDIA RTX Pro 6000, WD Ultrastar DC HA340' 
              },
            ]            
       }
      }, 
      ClientsFourList: {//Case Studies
       ES: [
            {        
              caption:' Industria 4',     
              headerOne: 'Energía e Industria',
              headerTwo: 'Exploración Geológica y Simulación de Ingeniería',
              bgImg:require('@/assets/Clients/Industry-4.webp'),
            },                     
        ],
        EN: [
            {      
              caption:'Industry 4',         
              headerOne: 'Energy & Industry',
              headerTwo: 'Geological Exploration & Engineering Simulation',
              bgImg:require('@/assets/Clients/Industry-4.webp'),
            },          
        ]
      },
      ClientsFourTarget:{
       ES:{ 
            Header:'Clientes Objetivo',
            information:[
              {
                name:'Compañías de petróleo y gas',
              },
              {
                name:'Empresas de diseño de ingeniería',
              },
              {
                name:'La industria de fabricación de alta gama',
              },
            ]                     
        },
        EN:{      
            Header:'Target Clients',
            information:[
              {
                name:'Oil & Gas Companies',
              },
              {
                name:'Engineering Design Firms',
              },
              {
                name:'High-end Manufacturing Industries',
              },
            ]            
       }
      }, 
      ClientsFourSolutions:{
       ES:{ 
            Header:'Solución Contextualizada',
            information:[
              {
                bgImg:require('@/assets/Clients/Industry-4-2-1.webp'),
                topImg:require('@/assets/Clients/Industry-4-2-2.webp'),
                name:'Desafío Central',
                content:'Procesar datos de exploración sísmica, ejecutar simulaciones complejas de ingeniería asistida por computadora, implementar gemelos digitales de alta precisión.',
              },
              {
                bgImg:require('@/assets/Clients/Industry-4-2-3.webp'),
                topImg:require('@/assets/Clients/Industry-4-2-4.webp'),
                name:'Combinación de Productos Central de Referencia',
                content:' NVIDIA H200, WD Ultrastar DC HA340', 
              },
            ]                     
        },
        EN:{      
            Header:'Scenario-based Solutions',
            information:[
              {
                bgImg:require('@/assets/Clients/Industry-4-2-1.webp'),
                topImg:require('@/assets/Clients/Industry-4-2-2.webp'),
                name:'Core Challenges',
                content:'Processing seismic survey data, running complex computer-aided engineering simulations, achieving high-precision digital twins.',              },
              {
                bgImg:require('@/assets/Clients/Industry-4-2-3.webp'),
                topImg:require('@/assets/Clients/Industry-4-2-4.webp'),
                name:'Recommended Core Product Combination',
                content:' NVIDIA H200, WD Ultrastar DC HA340',
              },
            ]            
       }
      }, 
      AboutWhy: {
        ES: {
             Header: '¿Por Qué Elegirnos?',
             content:' Como especialistas en importación y exportación de componentes centrales para servidores, con profunda experiencia en el mercado mexicano, nuestras competencias centrales se reflejan en:',
        },
        EN: {
             Header: 'Why Choose Us',
             content:'As a service provider focusing on the import and export of core server components, we deeply cultivate the Mexican market, with core competitiveness reflected in:',
        }
      },      
      AboutWhyList: {
        ES:[
          {
            caption:'Categorización Precisa',
            description:'Enfoque en componentes de funcionalidad central como almacenamiento y energía, rechazando consumibles de bajo valor. Cada producto pasa por doble prueba de compatibilidad y estabilidad.',
            InImg:require('@/assets/About/Why-Choose-Us1.webp'),
          },
          {
            caption:'Cadena de Suministro Controlable',
            description:'Establecimos asociaciones de distribución primaria con marcas globales reconocidas de componentes para servidores, reduciendo los plazos de entrega de componentes clave en un 30% compared al promedio del sector.',
            InImg:require('@/assets/About/Why-Choose-Us2.webp'),
          },
          {
            caption:'Garantía Localizada',
            description:'Formamos un equipo técnico local en México, ofreciendo servicios de consultoría en soluciones y resolución de fallas de productos.',
            InImg:require('@/assets/About/Why-Choose-Us3.webp'),
          },          
        ],
        EN:[
          {
            caption:'Precise Product Categories',
            description:'We focus on core functionality components like storage and power, avoiding low-value consumables. Every product undergoes dual testing for compatibility and stability.',
            InImg:require('@/assets/About/Why-Choose-Us1.webp'),
          },
          {
            caption:'Controllable Supply Chain',
            description:'We have established primary distributor partnerships with globally renowned server component brands, reducing lead times for core components by 30% compared to the industry average.',
            InImg:require('@/assets/About/Why-Choose-Us2.webp'),
          },
          {
            caption:'Localized Support',
            description:'We have built a local technical team in ESico, providing solution consulting and product troubleshooting services.',
            InImg:require('@/assets/About/Why-Choose-Us3.webp'),
          }, 
        ]
      },
      AboutContact: {
        ES: {
             Header: 'Contáctenos',
             content:'Siempre disponibles para atender sus necesidades, canales oficiales de consulta',
        },
        EN: {
             Header: 'Contact Us',
             content:'Connect with us anytime through official consultation channels',
        }
      },      
      AboutContactList: {
        ES:[
          {
            header:'Servicio al Cliente en Línea',
            explain:'Herramienta de comunicación integrada en el sitio web, respuesta en tiempo real durante horarios centrales de días laborables; se pueden dejar mensajes para respuesta posterior en horarios no laborables.',
            icon:require('@/assets/About/Contact-Us.png'),
          },
          {
            header:'Correo Electrónico Oficial',
            explain:'Correo comercial exclusivo con respuesta por email en 24 horas. Todas las necesidades de compra, consultas sobre soluciones y discusiones de colaboración pueden enviarse aquí.',
            icon:require('@/assets/About/Contact-Us.png'),
          },
          {
            header:'Atención Personalizada',
            explain:'Para necesidades de compra por volumen y soluciones personalizadas, se puede solicitar un asesor comercial dedicado para servicio uno a uno, dando seguimiento a la implementación de los requisitos.',
            icon:require('@/assets/About/Contact-Us.png'),
          },                    
        ],
        EN:[
          {
            header:'Online Chat',
            explain:'Built-in instant communication tool on the website, providing real-time responses during core business hours on weekdays; messages can be left for response outside these hours.',
            icon:require('@/assets/About/Contact-Us.png'),
          },
          {
            header:'Official Email',
            explain:'Exclusive business email offering 24-hour email response. All procurement needs, program consultations and cooperation negotiations can be sent here.',
            icon:require('@/assets/About/Contact-Us.png'),
          },
          {
            header:'Exclusive Docking',
            explain:'For bulk procurement and customized solution needs, you can apply for one-on-one service with an exclusive business consultant who will follow up the implementation of needs throughout the process.',
            icon:require('@/assets/About/Contact-Us.png'),
          }, 
 
        ]
      },  
      ServicesGuarantee:{
        ES: {
             Header: 'Garantías de Servicio',
             content:'Para una colaboración sin preocupaciones',
        },
        EN: {
             Header: 'Service Guarantee',
             content:'Worry-free Cooperation',
        }        
      },   
      ServicesGuaranteeList:{
       ES:[
               {
                 title:'Garantía de Originalidad y Compromiso de Calidad',
                 details:'Todos los componentes del servidor se adquieren directamente de fabricantes o canales autorizados, garantizando 100% originales. Desde la recepción de la mercancía, ofrecemos servicio de garantía original de 12 a 36 meses (según la categoría del producto). En caso de problemas de calidad no causados por mano de obra durante la garantía, se disfruta de reparación o reemplazo gratuito.',
                 img:require('@/assets/Services/Service-Guarantee1.webp'),
               },
               {
                 title:'Soluciones Flexibles de Compra y Pago',
                 details:'Ofrecemos planes personalizados según el volumen de compra: compras menores de stock disponible permiten pago inmediato y envío inmediato; compras por volumen disfrutan de descuentos por escalonamiento. Aceptamos pagos en Pesos ESicanos (MXN) y Dólares Estadounidenses (USD), los métodos de pago incluyen transferencia bancaria y principales plataformas de pago empresariales, satisfaciendo diversas necesidades financieras.',
                 img:require('@/assets/Services/Service-Guarantee2.webp'),
               },
               {
                 title:'Soporte Logístico y Postventa Localizado',
                 details:'Zonas centrales logran "pedido el mismo día, entrega al siguiente", áreas remotas reciben en 3-5 días laborables. Todos los pedidos incluyen número de seguimiento. Contamos con un equipo técnico profesional localizado, brindando soporte técnico remoto oportuno. Para problemas complejos, se puede programar la visita de un ingeniero en 48 horas, resolviendo instalación, configuración y diagnóstico de fallas de componentes.',
                 img:require('@/assets/Services/Service-Guarantee3.webp'),
               },               
          ] ,                    
        EN:[
               {
                 title:'Authenticity Guarantee & Quality Commitment',
                 details:'All server components are directly purchased from brand original factories or authorized channels to ensure 100% authenticity. From the date of receipt of goods, we provide original factory warranty services ranging from 12 to 36 months (depending on the product category). For non-human-caused quality problems during the warranty period, free repair or replacement services are available.',
                 img:require('@/assets/Services/Service-Guarantee1.webp'),
               },
               {
                 title:'Flexible Procurement & Payment Solutions',
                 details:'Customized solutions are provided for different procurement scales: small-quantity spot procurement supports instant payment and immediate shipment; bulk procurement can enjoy tiered price discounts. Dual-currency payment in ESican Peso (MXN) and US Dollar (USD) is supported, with payment methods covering mainstream corporate payment platforms such as bank transfers to meet diverse financial needs.',
                 img:require('@/assets/Services/Service-Guarantee2.webp'),
               },
               {
                 title:' Authenticity Guarantee & Quality Commitment',
                 details:'Core areas achieve "order today, receive tomorrow," remote areas receive within 3-5 business days. All orders come with logistics tracking numbers. We have a professional, localized technical service team providing timely remote technical support. For complex issues, an engineer can be scheduled for an on-site visit within 48 hours to resolve component installation, debugging, and fault diagnosis.',
                 img:require('@/assets/Services/Service-Guarantee3.webp'),
               },
          ],

      },
      ServicesCooperation:{
        ES: {
             Header: 'Proceso de Colaboración',
             content:'3 Pasos para Completar su Compra Rápidamente',
        },
        EN: {
             Header: 'Cooperation Process',
             content:'3 Quick Steps to Complete Your Purchase',
        }        
      }, 
      ServicesCooperationList:{
       ES:[        
               {
                 title:'Alineación de Requerimientos',
                 details:'Envíe sus necesidades de compra a través de nuestros canales oficiales de consultoría, especificando modelo, cantidad, tiempo de entrega y requisitos especiales. Le emitiremos una cotización detallada y una descripción de la solución lo antes posible.',
                 link:'/',
                 icon:require('@/assets/Services/Cooperation-Process1.png'),
               },
               {
                 title:'Firma de Contrato y Pago',
                 details:'Una vez confirmada la cotización, ambas partes firman un contrato de compra formal (admite contrato electrónico y físico). El cliente completa el pago según lo acordado en el contrato. El envío se programa dentro de las 12 horas posteriores a la acreditación del pago.',
                 link:'/',
                 icon:require('@/assets/Services/Cooperation-Process2.png'),
               },
               {
                 title:'Recepción y Seguimiento Postventa',
                 details:'Tras la recepción de la mercancía por parte del cliente, daremos seguimiento proactivo al estado de la inspección de recepción. Durante el período de garantía, realizamos visitas de seguimiento periódicas, ofreciendo recomendaciones de mantenimiento para los componentes, asegurando la operación estable del equipo.',
                 link:'/',
                 icon:require('@/assets/Services/Cooperation-Process3.png'),
               },                
          ] ,                    
        EN:[
               {
                 title:'Demand Docking',
                 details:'Submit procurement needs through official consultation channels, specifying product models, quantities, delivery times and special requirements. We will issue detailed quotations and program descriptions as soon as possible.',
                 link:'/',
                 icon:require('@/assets/Services/Cooperation-Process1.png'),
               },
               {
                 title:'Contract Signing & Payment',
                 details:'After confirming the quotation, both parties sign a formal procurement contract (electronic and paper contracts are supported). The customer completes the payment in accordance with the contract agreement, and the goods will be arranged for shipment within 12 hours after the payment is received.',
                 link:'/',
                 icon:require('@/assets/Services/Cooperation-Process2.png'),
               },
               {
                 title:'Receipt & After-sales Follow-up',
                 details:' After the customer receives the goods, we will take the initiative to follow up the acceptance situation; regular return visits will be conducted during the warranty period to provide component maintenance suggestions and ensure the stable operation of the equipment.',
                 link:'/',
                 icon:require('@/assets/Services/Cooperation-Process3.png'),
               },
          ],

      },
    }
  },
  reducers: {
    setLanguage: (state, action) => {
      state.currentLanguage = action.payload;
    }
  }
});

// 导出actions
export const { setLanguage } = globalSlice.actions;

// 导出选择器函数
export const getCurrentLanguage = (state) => state.global.currentLanguage;
export const getTranslations = (state) => state.global.translations;

export default globalSlice.reducer;